import { render } from "./TabsContainer.vue?vue&type=template&id=2c963dc2&scoped=true"
import script from "./TabsContainer.vue?vue&type=script&lang=js"
export * from "./TabsContainer.vue?vue&type=script&lang=js"

import "./TabsContainer.vue?vue&type=style&index=0&id=2c963dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c963dc2"]])

export default __exports__